import { motion } from 'framer-motion';

export default function SponsorsSection() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#101A2E] mb-12 text-center" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Наши спонсоры
          </h2>
          
          <div className="flex justify-center items-center">
            <img 
              src="img/sponsor.png"
              alt="Логотипы спонсоров: CSC pharma, Bayer, Акрихин, Dr.Reddy's, Unipharm"
              className="w-full max-w-5xl h-auto object-contain"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}